import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { DataFormatter, sortByDate, sortByScenarioIdAndYear } from './lib/dataFormatter'
const urlPrefix = process.env.BASE_URL === '/' ? '' : process.env.BASE_URL
Vue.use(Vuex)

function detectmob () {
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true
  } else {
    return false
  }
}

export default new Vuex.Store({
  state: {
    lang: window.localStorage.getItem('lang') || 'English',
    basePath: process.env.BASE_URL,
    audioDeactivated: (detectmob() || navigator.vendor.match(/Apple/i)) ? true : process.env.VUE_APP_AUDIO_DEACTIVATED === 1,
    eventId: 'welcome',
    pagePosition: 0,
    storyDataLoaded: false,
    mapDataLoaded: false,
    campSitesDataLoaded: false,
    storyData: null,
    storyDataInuktitut: null,
    mapData: null,
    selectedGeometry: null,
    modal: {
      opened: false
    },
    menuOpened: false,
    isMobile: detectmob()
  },
  getters: {
    screensData: state => {
      const storyData = state.lang === 'English' ? state.storyData : state.storyDataInuktitut
      if (storyData) {
        storyData[ storyData.length - 1 ].isLast = true
        return [
          { itemType: 'landing', slug: 'welcome' },
          { itemType: 'intro', slug: 'introduction' },
          ...storyData
        ]
      } else {
        return null
      }
    },
    storyData: state => state.lang === 'English' ? state.storyData : state.storyDataInuktitut
  },
  mutations: {
    setLang (state, value) {
      state.lang = value
    },
    setMenuOpened (state, value) {
      state.menuOpened = value
    },
    setAudioDeactivated (state, value) {
      state.audioDeactivated = value
    },
    setSelectedGeometry (state, value) {
      state.selectedGeometry = value
    },
    setEventId (state, value) {
      state.eventId = value
    },
    setPagePosition (state, value) {
      state.pagePosition = value
    },
    setStoryData (state, data) {
      state.storyData = data
    },
    setStoryDataInuktitut (state, data) {
      state.storyDataInuktitut = data
    },
    setCampSitesData (state, data) {
      state.campSitesData = data
    },
    setMapData (state, data) {
      state.mapData = data
    },
    setStoryDataLoaded (state, loaded) {
      state.storyDataLoaded = loaded
    },
    setCampSitesDataLoaded (state, loaded) {
      state.campSitesDataLoaded = loaded
    },
    setMapDataLoaded (state, loaded) {
      state.mapDataLoaded = loaded
    },
    setModalOpened (state, opened) {
      state.modal.opened = opened
    }
  },
  actions: {
    async loadMediaData ({ state, commit }) {
      const configs = [
        { type: 'event', url: process.env.VUE_APP_DATA_STORY_PATH, filter: story => typeof story.date !== 'undefined' },
        { type: 'campsite', url: process.env.VUE_APP_DATA_CAMPSITES_PATH, filter: item => item } // typeof item.year !== 'undefined' }
      ]
      configs.forEach(async config => {
        const response = await axios.get(urlPrefix + config.url)
        const formattedData = response.data.content
          .map(item => new DataFormatter(item, config.type))
          .filter(config.filter)

        if (config.type === 'event') {
          formattedData.sort(sortByDate)
          commit(
            'setStoryData',
            formattedData.filter(event => event.language === 'English')
          )
          commit(
            'setStoryDataInuktitut',
            formattedData.filter(event => event.language === 'Inuktitut')
          )
          commit('setStoryDataLoaded', true)
        } else {
          formattedData.sort(sortByScenarioIdAndYear)
          commit(
            'setCampSitesData',
            formattedData
          )
          commit('setCampSitesDataLoaded', true)
        }
      })
    },
    async loadMapData ({ state, commit }) {
      const mapDataResponse = await axios.get(urlPrefix + process.env.VUE_APP_DATA_MAP_PATH)
      const features = mapDataResponse.data.features
      commit('setMapData', features)
      commit('setMapDataLoaded', true)
    },
    next ({ state, getters }) {
      const screensData = getters.screensData
      const currentIndex = screensData.findIndex(eventData => eventData.slug === state.eventId)
      const nextEvent = screensData[currentIndex + 1]
      if (nextEvent) {
        window.location.href = '#' + nextEvent.slug
      }
    },
    previous ({ state, getters }) {
      const screensData = getters.screensData
      const currentIndex = screensData.findIndex(eventData => eventData.slug === state.eventId)
      const previousScreen = screensData[currentIndex - 1]
      if (previousScreen) {
        window.location.href = '#' + previousScreen.slug
      }
    },
    unselectGeometry ({ commit }) {
      commit('setSelectedGeometry', null)
      commit('setModalOpened', false)
    },
    changeLanguage ({ commit }, newLang) {
      commit('setEventId', 'welcome')
      commit('setLang', newLang)
      window.localStorage.setItem('lang', newLang)
      window.location.href = '#welcome'
    }
  }
})
